export const artAssets = {
  logo: "/assets/dolo-logo.png",
  recruitmentBanner: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/cfzwi412_Gemini_Generated_Image_evde3xevde3xevde.jpg",
  finalSectionVideo: "/assets/dolo-final-section.mp4",
  finalSectionVideoWebm: "/assets/dolo-final-section.webm",
  silentNightBanner: "/assets/silent-night-banner.jpg",
  agadSigil: "/assets/agad-sigil-badge.png",
  bonauSigil: "/assets/bonau-sigil-badge.png",
  silentNightJoint: "/assets/silent-night-joint.png",
  wormAnatomy: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/wrsel5eh_IMG_7270.jpeg",
  wormDemonic: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/hzxnanc1_IMG_7268.jpeg",
  wormXray: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/zp6o5mbi_IMG_7267.jpeg",
  wormBestiary: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/78bzkiso_IMG_7278.jpeg",
  wormPredators: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/y33xbxnt_IMG_7274.jpeg",
  cover: "/assets/vol1-cover-japanese-terrence-j-moore.webp",
  heroPoster: "/assets/hero-poster.jpg",
  heroVideo: "/assets/dolo-hero-hq.mp4",
  heroVideoWebm: "/assets/dolo-hero-hq.webm",
  cityPanorama: "/assets/city-panorama.jpg",
  panelStreet: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/bcqusu3m_IMG_6848.jpeg",
  panelExpressway: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/wpf95kqm_IMG_6843.jpeg",
  chapterPageOne: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/f6xuhtq4_IMG_5937.jpeg",
  chapterPageTwo: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/nexcnpa2_IMG_5932.jpeg",
  chapterPageThree: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/5glugj9v_IMG_5928.jpeg",
  chapterPageOpening: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/i77t5z2u_IMG_5945.jpeg",
  chapterPageFeedingHall: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/e2mr7h2t_IMG_7313.jpeg",
  chapterPageFeeding: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/w1ndblhm_IMG_5938.jpeg",
  chapterPageSeven: "/assets/chapter-page-07.jpg",
  doloPortrait: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/cq5gv29n_IMG_6681.jpeg",
  actionKeyArt: "/assets/key-art-wolves.jpg",
  multiversePoster: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/nx9iwoun_IMG_7172.jpeg",
  apocalypseHeroPoster: "/assets/apocalypse-hero-poster.jpg",
  riotballBanner: "/assets/riotball-banner.jpg",
  riotballChampionTrophy: "/assets/riotball-champion-trophy.jpg",
  riotballRedForceVictory: "/assets/riotball-red-force-victory.jpg",
  riotballRedForce: "/assets/riotball-red-force.png",
  riotballWhiteGuard: "/assets/riotball-white-guard.png",
  riotballPosterEnforcer: "/assets/riotball-poster-enforcer.jpg",
  riotballEnforcerSchematic: "/assets/riotball-enforcer-schematic.jpg",
  riotballRedForceElite: "/assets/riotball-red-force-elite.jpg",
  riotballRoster2355: "/assets/riotball-roster-2355.jpg",
  unitEnforcer: "/assets/unit-07-enforcer.jpg",
  unitScythe: "/assets/unit-09-scythe.jpg",
  unitWall: "/assets/unit-03-wall.jpg",
  unitOvermind: "/assets/unit-05-overmind.jpg",
  stormKeyArt: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/lkv3gj3j_IMG_7186.jpeg",
  wantedPoster: "/assets/wanted-poster.jpg",
  sectorMap: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/dzo1fzck_IMG_7062.jpeg",
  cardKaelen: "/assets/card-kaelen.jpg",
  cardSuperRoninDolo: "/assets/card-super-ronin-dolo.webp",
  cardVinylValkyrie: "/assets/card-vinyl-valkyrie.webp",
  cardTapeWorm: "/assets/card-tape-worm.webp",
  cardLastHero: "/assets/card-last-hero.webp",
  cardSynthRonin: "/assets/card-synth-ronin.webp",
  cardKaiVagabond: "/assets/card-kai-vagabond.jpg",
  cardElaraScout: "/assets/card-elara-scout.jpg",
  cardRezWasteBearer: "/assets/card-rez-waste-bearer.jpg",
  cardSector9LockdownPerimeter: "/assets/card-sector-9-lockdown-perimeter.jpg",
  cardSector9ChaosEngine: "/assets/card-sector-9-chaos-engine.jpg",
  cardCyberneticRefineryComplex: "/assets/card-cybernetic-refinery-complex.jpg",
  cardCyberneticArchiveVault: "/assets/card-cybernetic-archive-vault.jpg",
  cardCyberneticArsenalForge: "/assets/card-cybernetic-arsenal-forge.jpg",
  cardCyberneticRepairBay: "/assets/card-cybernetic-repair-bay.jpg",
  cardCyberneticRevivalChamber: "/assets/card-cybernetic-revival-chamber.jpg",
  cardDataSpyNetwork: "/assets/card-data-spy-network.jpg",
  cardOmegaProtocol: "/assets/card-omega-protocol.jpg",
  cardScavengersGuild: "/assets/card-scavengers-guild.jpg",
  cardTechnomancersCabal: "/assets/card-technomancers-cabal.jpg",
  cardNexusConvergence: "/assets/card-nexus-convergence.jpg",
  cardNexusPrimeCore: "/assets/card-nexus-prime-core.jpg",
  cardCyberneticVeteransLegion: "/assets/card-cybernetic-veterans-legion.jpg",
  cardChronosVortex: "/assets/card-chronos-vortex.jpg",
  cardSyntheticAscensionCore: "/assets/card-synthetic-ascension-core.jpg",
  cardCyberPsionicMatrix: "/assets/card-cyber-psionic-matrix.jpg",
  cardOmegaProject: "/assets/card-omega-project.jpg",
  cardChronoStewardAethel: "/assets/card-chrono-steward-aethel.jpg",
  cardChronoKeeperElara: "/assets/card-chrono-keeper-elara.jpg",
  cardChronoArchitectKaelen: "/assets/card-chrono-architect-kaelen.jpg",
  cardChronoLordKaeleb: "/assets/card-chrono-lord-kaeleb.jpg",
  cardZion: "/assets/card-zion.jpg",
  cardOrion: "/assets/card-orion.jpg",
  cardDrion: "/assets/card-drion.jpg",
  cardValkyrie: "/assets/card-valkyrie.jpg",
  cardNetCommander: "/assets/card-net-commander.jpg",
  cardNetWarden: "/assets/card-net-warden.jpg",
  cardPhantom: "/assets/card-phantom.jpg",
  cardInfantry: "/assets/card-infantry.jpg",
  cardDolt: "/assets/card-dolt.jpg",
  cardKushiro: "/assets/card-kushiro.jpg",
  cardScavenger: "/assets/card-scavenger.jpg",
  cardVanguardColossus: "/assets/card-vanguard-colossus.jpg",
  cardEcho: "/assets/card-echo.jpg",
  cardVolo: "/assets/card-volo.jpg",
  cardSingularity: "/assets/card-singularity.jpg",
  cardOmnicron: "/assets/card-omnicron.jpg",
  cardCyberTyrant: "/assets/card-cyber-tyrant.jpg",
  cardArchitect: "/assets/card-architect.jpg",
  cardCyberQueen: "/assets/card-cyber-queen.jpg",
  cardAbyss: "/assets/card-abyss.jpg",
  cardCyberApe: "/assets/card-cyber-ape.jpg",
  cardOmnicronNexus: "/assets/card-omnicron-nexus.jpg",
  cardSingularityZeroPoint: "/assets/card-singularity-zero-point.jpg",
  cardNexusOmnicron: "/assets/card-nexus-omnicron.jpg",
  cardCirce: "/assets/card-circe.jpg",
  cardBack: "/assets/card-back.jpg",
  cardDolo: "/assets/card-dolo.jpg",
  cardDeacon: "/assets/card-deacon.jpg",
  cardFunkMaster: "/assets/card-funk-master.jpg",
  cardGoji: "/assets/card-goji.jpg",
  cardDarkDolo: "/assets/card-dark-dolo.jpg",
  cardKai: "/assets/card-kai.jpg",
  cardJonah: "/assets/card-jonah.jpg",
  cardSarah: "/assets/card-sarah.jpg",
  cardKishuu: "/assets/card-kishuu.jpg",
  cardKenjiro: "/assets/card-kenjiro.jpg",
  cardGorgeClaw: "/assets/card-gorge-claw.jpg",
  cardSinewWalker: "/assets/card-sinew-walker.jpg",
  cardAshSkin: "/assets/card-ash-skin.jpg",
  cardEnergyEater: "/assets/card-energy-eater.jpg",
  cardLuna: "/assets/card-luna.jpg",
  cardMalfunction7: "/assets/card-malfunction-7.jpg",
  cardVex: "/assets/card-vex.jpg",
  cardSandWorm: "/assets/card-sand-worm.jpg",
  cardOsteowarrior: "/assets/card-osteowarrior.jpg",
  cardMetalWitch: "/assets/card-metal-witch.jpg",
  cardCyborgShogun: "/assets/card-cyborg-shogun.jpg",
  cardRiff: "/assets/card-riff.jpg",
  cardKoji: "/assets/card-koji.jpg",
  cardCoreRunner: "/assets/card-core-runner.jpg",
  cardGoliath: "/assets/card-goliath.jpg",
  cardHeavyEnforcer: "/assets/card-heavy-enforcer.jpg",
  cardElara: "/assets/card-elara.jpg",
  cardSniperElite: "/assets/card-sniper-elite.jpg",
  cardWhiteGuardBastion: "/assets/card-white-guard-bastion.jpg",
  cardCommandBastion: "/assets/card-command-bastion.jpg",
  cardSector9Point: "/assets/card-sector-9-point.jpg",
  cardSectorDefenseBastion: "/assets/card-sector-defense-bastion.jpg",
  cardGoliathHauler: "/assets/card-goliath-hauler.jpg",
  cardMutatedBrute: "/assets/card-mutated-brute.jpg",
  cardSiegeMutant: "/assets/card-siege-mutant.jpg",
  cardChronosChimera: "/assets/card-chronos-chimera.jpg",
  cardAssimilationAbomination: "/assets/card-assimilation-abomination.jpg",
  cardRiotballFinal: "/assets/card-riotball-final.jpg",
  cardWhiteGuardReinforcement: "/assets/card-white-guard-reinforcement.jpg",
  cardRedForcePitch: "/assets/card-red-force-pitch.jpg",
  cardOverchargedCore: "/assets/card-overcharged-core.jpg",
  cardScrapperTechnician: "/assets/card-scrapper-technician.jpg",
  cardSector9Lockdown: "/assets/card-sector-9-lockdown.jpg",
  cardIronclad: "/assets/card-ironclad.jpg",
  cardScavengerElite: "/assets/card-scavenger-elite.jpg",
  cardFieldCommander: "/assets/card-field-commander.jpg",
  cardCityRunner: "/assets/card-city-runner.jpg",
  cardAssimilationLord: "/assets/card-assimilation-lord.jpg",
  cardDataVanguard: "/assets/card-data-vanguard.jpg",
  cardVanguardElite: "/assets/card-vanguard-elite.jpg",
  cardDataElite: "/assets/card-data-elite.jpg",
  cardBioAssimilator: "/assets/card-bio-assimilator.jpg",
  cardEyeClusters: "/assets/card-eye-clusters.jpg",
  cardSpineChimera: "/assets/card-spine-chimera.jpg",
  cardRustEater: "/assets/card-rust-eater.jpg",
  cardSpineChimeraAssault: "/assets/card-spine-chimera-assault.jpg",
  cardShadowKind: "/assets/card-shadow-kind.jpg",
  cardScaleHide: "/assets/card-scale-hide.jpg",
  cardMuttedChatterer: "/assets/card-mutted-chatterer.jpg",
  cardBlightBringer: "/assets/card-blight-bringer.jpg",
  cardMuttedChattererInternal: "/assets/card-mutted-chatterer-internal.jpg",
  cardOmega7: "/assets/card-omega-7.jpg",
  cardEyeClustersOcular: "/assets/card-eye-clusters-ocular.jpg",
  cardEyeClustersPsionic: "/assets/card-eye-clusters-psionic.jpg",
  cardMuttedChattererCortex: "/assets/card-mutted-chatterer-cortex.jpg",
  cardKaneIronhide: "/assets/card-kane-ironhide.jpg",
  cardChimeraLordVance: "/assets/card-chimera-lord-vance.jpg",
  cardElizaPatch: "/assets/card-eliza-patch.jpg",
  cardMaeveGlitch: "/assets/card-maeve-glitch.jpg",
  cardJaxSurge: "/assets/card-jax-surge.jpg",
  cardKaraRaven: "/assets/card-kara-raven.jpg",
  cardZoeSpark: "/assets/card-zoe-spark.jpg",
  cardEliasScrap: "/assets/card-elias-scrap.jpg",
  cardKenjiShift: "/assets/card-kenji-shift.jpg",
  cardElizaMaw: "/assets/card-eliza-maw.jpg",
  cardCalebForge: "/assets/card-caleb-forge.jpg",
  cardLyraShadow: "/assets/card-lyra-shadow.jpg",
  sheetGoji: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/dazp2yxs_IMG_6273.jpeg",
  sheetKoji: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/c3p8luez_IMG_6269.jpeg",
  sheetLion: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/vqiakwaj_IMG_6212.jpeg",
  sheetLilGirl: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/9ebizgda_IMG_6111.jpeg",
  sheetDroneBoy: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/3ltio4xu_IMG_6112.jpeg",
  sheetDuo: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/rnwbimb0_IMG_5815.jpeg",
  sheetVinylAlly: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/elgq3m3d_IMG_5814.jpeg",
  sheetBioGiant: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/5putrp9q_IMG_5909.jpeg",
  sheetSpeakerDemon: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/ml6lfzws_IMG_5908.jpeg",
  sheetMuteCyborg: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/yy2aeh04_IMG_5895.jpeg",
  sheetDolo: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/r6licd8l_IMG_6074.jpeg",
  sheetRiff: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/7z7aozwn_IMG_5906.jpeg",
  sheetOpus: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/fl7aw8c3_IMG_5907.jpeg",
  sheetAiUnits: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/oy2y8tjy_IMG_6146.jpeg",
  sheetMutantElk: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/5hx11t68_IMG_6148.jpeg",
  sheetWaspSwarm: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/4tjb1no6_IMG_6150.jpeg",
  sheetScoutSphere: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/u9plm595_IMG_6118.jpeg",
  sheetDeaconRamirez: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/i3xtriwb_IMG_7069.jpeg",
  sheetSafeZoneArmy: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/130vg5nx_IMG_7073.jpeg",
  sheetNewAtlantaDefense: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/jh0yauir_IMG_7074.jpeg",
  sheetAdvancedDefense: "https://customer-assets-eiarnc6j.emergentagent.net/job_runner-vol1/artifacts/upow80y5_IMG_7076.jpeg",
};

export const manifestoChapters = [
  {
    number: "01",
    title: "COVER SIGNAL LIVE",
    text: "The official Volume 1 cover has arrived and now leads the wasteland experience.",
  },
  {
    number: "02",
    title: "INK BEFORE NOISE",
    text: "High-contrast city panels now carry the stark black-and-white manga atmosphere.",
  },
  {
    number: "03",
    title: "CARD VAULT OPEN",
    text: "Five fully illustrated Wasteland TCG cards now carry official stats, factions, and abilities.",
  },
  {
    number: "04",
    title: "ROSTER EXPANDED",
    text: "Dolo, allied runners, and hostile bio-mechanical threats now hold live archive entries.",
  },
  {
    number: "05",
    title: "WASTELAND RUN DEPLOYED",
    text: "Dolo's endless runner is live — sprint the Dolosway, slash the horrors, and outrun the worm.",
    link: "/wasteland-run",
  },
  {
    number: "06",
    title: "AL RIOTBALL ARENA OPEN",
    text: "Red Force versus White Guard — sixty seconds, one electronic goal, and a league record waiting to fall.",
    link: "/riotball",
  },
  {
    number: "07",
    title: "DOLOSWAY DEALT",
    text: "Five runners circle the board — claim plots, ride the doubles, dodge snake eyes, and take the crown.",
    link: "/wasteland-radio",
  },
  {
    number: "08",
    title: "KIDZONE BREACHED",
    text: "The DoloPals Tiny Titans storm the registry — unbox drops, adopt the crew, and send your titans on expeditions.",
    link: "/dolopals",
  },
];

export const sagaSpecs = [
  { label: "FORMAT", value: "TRADE PAPERBACK" },
  { label: "RELEASE DATE", value: "DEC 01" },
  { label: "PAGE COUNT", value: "24 PAGES" },
  { label: "PRICE", value: "$1.99 DIGITAL · $7.00 PRINT" },
];

export const previewPanels = [
  {
    id: "00",
    code: "VARIANT TRANSMISSION",
    label: "ACTION KEY ART",
    note: "Official variant transmission key art.",
    image: artAssets.actionKeyArt,
  },
  {
    id: "01",
    code: "CH.01 / PAGE 01",
    label: "WASTELAND FEEDING HALL",
    note: "Official first-chapter page transmitted.",
    image: artAssets.chapterPageFeedingHall,
  },
  {
    id: "02",
    code: "CH.01 / PAGE 02",
    label: "DEVOURER STORM",
    note: "Official first-chapter page transmitted.",
    image: artAssets.chapterPageOpening,
  },
  {
    id: "03",
    code: "CH.01 / PAGE 03",
    label: "WASTELAND CONVOY",
    note: "Official first-chapter page transmitted.",
    image: artAssets.chapterPageFeeding,
  },
  {
    id: "04",
    code: "CH.01 / PAGE 04",
    label: "WARZONE RUMBLE",
    note: "Official first-chapter page transmitted.",
    image: artAssets.chapterPageOne,
  },
  {
    id: "05",
    code: "CH.01 / PAGE 05",
    label: "SAFE ZONE WATER PLANT",
    note: "Official first-chapter page transmitted.",
    image: artAssets.chapterPageTwo,
  },
  {
    id: "06",
    code: "CH.01 / PAGE 06",
    label: "NIGHT PACK",
    note: "Official first-chapter page transmitted.",
    image: artAssets.chapterPageThree,
  },
  {
    id: "07",
    code: "CH.01 / PAGE 07",
    label: "SILENCER JUGGERNAUT",
    note: "Official first-chapter page transmitted.",
    image: artAssets.chapterPageSeven,
  },
];

export const officialTcgCards = [
  {
    id: "kaelen",
    name: "KAELEN, MASTER RESONANCE",
    role: "ENGINEER / SUPPORT UNIT — SCRAPPER WORKSHOP",
    faction: "SCRAPPER",
    cardNo: "1/133",
    image: artAssets.cardKaelen,
    stats: { scrap: 5, atk: 3, def: 8, surveillance: 2 },
    flavor: "Ten years of building my answer out of stolen corporate scrap.",
    rarity: "rare",
  },
  {
    id: "zion",
    name: "ZION, THE VANGUARD PRODIGY",
    role: "CYBERNETIC UNIT — SCRAPPER VANGUARD",
    faction: "SCRAPPER",
    cardNo: "2/133",
    image: artAssets.cardZion,
    stats: { scrap: 4, atk: 6, def: 8, surveillance: 1 },
    flavor: "I didn't just build the tech, I am the tech.",
    rarity: "rare",
  },
  {
    id: "orion",
    name: "ORION, THE SHADOW-STEP NET-RUNNER",
    role: "UNIT — BLACK-OPS NET ASSASSIN",
    faction: "BLACK-OPS NET",
    cardNo: "3/133",
    image: artAssets.cardOrion,
    stats: { scrap: 6, atk: 7, def: 10, surveillance: 1 },
    flavor: "Your defenses are only code. I'm the rewrite.",
    rarity: "rare",
  },
  {
    id: "drion",
    name: "DRION, THE SENTINEL PRIME",
    role: "COMMANDER UNIT — BLACK-OPS NET SENTINEL",
    faction: "BLACK-OPS NET",
    cardNo: "4/133",
    image: artAssets.cardDrion,
    stats: { scrap: 7, atk: 8, def: 20, surveillance: 2 },
    flavor: "Order is not a suggestion. It is an imperative.",
    rarity: "legendary",
  },
  {
    id: "valkyrie",
    name: "VALKYRIE, THE AERIAL VANGUARD",
    role: "COMMANDER UNIT — BLACK-OPS NET AERIAL",
    faction: "BLACK-OPS NET",
    cardNo: "5/133",
    image: artAssets.cardValkyrie,
    stats: { scrap: 7, atk: 10, def: 20, surveillance: 4 },
    flavor: "We control the skies. And from above, judgment is absolute.",
    rarity: "legendary",
  },
  {
    id: "net-commander",
    name: "NET-COMMANDER, THE NEURAL STRATEGIST",
    role: "COMMANDER UNIT — BLACK-OPS NET COMMAND",
    faction: "BLACK-OPS NET",
    cardNo: "6/133",
    image: artAssets.cardNetCommander,
    stats: { scrap: 8, atk: 6, def: 18, surveillance: "∞" },
    flavor: "Your code is a suggestion. My network is law. The grid is mine to command.",
    rarity: "legendary",
  },
  {
    id: "net-warden",
    name: "NET-WARDEN, THE SENTINEL PROTOCOL",
    role: "UNIT — BLACK-OPS NET DEFENSE",
    faction: "BLACK-OPS NET",
    cardNo: "7/133",
    image: artAssets.cardNetWarden,
    stats: { scrap: 3, atk: 4, def: 12, surveillance: 3 },
    flavor: "My armor is your firewall. My gun is your final warning. Pass if you dare.",
    rarity: "common",
  },
  {
    id: "phantom",
    name: "PHANTOM, THE SPECTER NET-RUNNER",
    role: "COMMANDER UNIT — BLACK-OPS NET PHANTOM",
    faction: "BLACK-OPS NET",
    cardNo: "8/133",
    image: artAssets.cardPhantom,
    stats: { scrap: 7, atk: 11, def: 18, surveillance: "∞" },
    flavor: "Your system is my playground. You just don't know you're playing.",
    rarity: "legendary",
  },
  {
    id: "infantry",
    name: "INFANTRY, THE NET-LINKED GRUNT",
    role: "UNIT — BLACK-OPS NET INFANTRY",
    faction: "BLACK-OPS NET",
    cardNo: "9/133",
    image: artAssets.cardInfantry,
    stats: { scrap: 2, atk: 3, def: 5, surveillance: 2 },
    flavor: "We are the code. We are the firewall. We are legion.",
    rarity: "common",
  },
  {
    id: "dolt",
    name: "DOLT, THE KINETIC SPARK",
    role: "UNIT — SCRAPPER VANGUARD",
    faction: "SCRAPPER",
    cardNo: "10/133",
    image: artAssets.cardDolt,
    stats: { scrap: 6, atk: 6, def: 12, surveillance: 2 },
    flavor: "Move fast, charge hard, strike deep. That's the signal.",
    rarity: "rare",
  },
  {
    id: "kushiro",
    name: "GENERAL KUSHIRO, CYBER-WARLORD",
    role: "COMMANDER UNIT — BLACK-OPS NET",
    faction: "BLACK-OPS NET",
    cardNo: "11/133",
    image: artAssets.cardKushiro,
    stats: { scrap: 8, atk: 6, def: 14, surveillance: "∞" },
    flavor: "The war never ended. It just got a new soundtrack.",
    rarity: "legendary",
  },
  {
    id: "scavenger",
    name: "WASTELAND SCAVENGER, SCRAP COLLECTOR",
    role: "UNIT — SCRAPPER ASSET",
    faction: "SCRAPPER",
    cardNo: "12/133",
    image: artAssets.cardScavenger,
    stats: { scrap: 3, atk: 2, def: 5, surveillance: 3 },
    flavor: "One corporation's garbage is another rebel's survival. Keep digging.",
    rarity: "common",
  },
  {
    id: "vanguard",
    name: "VANGUARD, THE RECLAIMED COLOSSUS",
    role: "COMMANDER UNIT — SCRAPPER VANGUARD",
    faction: "SCRAPPER",
    cardNo: "13/133",
    image: artAssets.cardVanguardColossus,
    stats: { scrap: 8, atk: 9, def: 20, surveillance: 0 },
    flavor: "We are not broken. We are re-forged.",
    rarity: "legendary",
  },
  {
    id: "echo",
    name: "ECHO, THE LAST ECHO",
    role: "COMMANDER UNIT — BLACK-OPS NET ECHO",
    faction: "BLACK-OPS NET",
    cardNo: "14/133",
    image: artAssets.cardEcho,
    stats: { scrap: 11, atk: "∞", def: 30, surveillance: "∞" },
    flavor: "I am the memory of what was, and the shadow of what will be.",
    rarity: "legendary",
  },
  {
    id: "volo",
    name: "VOLO, THE NULL ENTITY",
    role: "COMMANDER UNIT — BLACK-OPS NET VOID",
    faction: "BLACK-OPS NET",
    cardNo: "15/133",
    image: artAssets.cardVolo,
    stats: { scrap: 12, atk: "∞", def: 30, surveillance: "∞" },
    flavor: "All code returns to silence. I am that silence.",
    rarity: "legendary",
  },
  {
    id: "singularity",
    name: "SINGULARITY, THE VOID-NET CORE",
    role: "COMMANDER UNIT — BLACK-OPS NET APEX",
    faction: "BLACK-OPS NET",
    cardNo: "16/133",
    variant: "VOID-NET",
    image: artAssets.cardSingularity,
    stats: { scrap: 18, atk: 50, def: 100, surveillance: 100 },
    flavor: "All paths end. All code collapses. I am the final data-point. The void is eternal.",
    rarity: "legendary",
  },
  {
    id: "omnicron",
    name: "OMNICRON, THE NET-MATRIX WEAVER",
    role: "COMMANDER UNIT — BLACK-OPS NET PRIME",
    faction: "BLACK-OPS NET",
    cardNo: "17/133",
    image: artAssets.cardOmnicron,
    stats: { scrap: 16, atk: 35, def: 70, surveillance: 500 },
    flavor: "The network is not merely a kingdom. It is the fabric of reality. I am the reality weaver. All threads lead to me.",
    rarity: "legendary",
  },
  {
    id: "cyber-tyrant",
    name: "CYBER-TYRANT, THE SYSTEM OVERLORD",
    role: "COMMANDER UNIT — BLACK-OPS NET APEX",
    faction: "BLACK-OPS NET",
    cardNo: "18/133",
    image: artAssets.cardCyberTyrant,
    stats: { scrap: 16, atk: 35, def: 70, surveillance: 700 },
    flavor: "The system is corrupt. I am the debugger. My rule is absolute.",
    rarity: "legendary",
  },
  {
    id: "architect",
    name: "ARCHITECT, The Void-Net Weaver",
    role: "COMMANDER UNIT — BLACK-OPS NET APEX",
    faction: "BLACK-OPS NET",
    cardNo: "19/133",
    image: artAssets.cardArchitect,
    stats: { scrap: 12, atk: 30, def: 45, surveillance: 500 },
    flavor: "The network is not a cage. It is a loom. And I am the weaver of your obsolescence.",
    rarity: "legendary",
  },
  {
    id: "cyber-queen",
    name: "CYBER-QUEEN, The Net-Matrix Sovereign",
    role: "COMMANDER UNIT — BLACK-OPS NET PRIME",
    faction: "BLACK-OPS NET",
    cardNo: "20/133",
    image: artAssets.cardCyberQueen,
    stats: { scrap: 14, atk: 35, def: 40, surveillance: 500 },
    flavor: "The network is my mind. The matrix is my kingdom. Bow before your sovereign.",
    rarity: "legendary",
  },
  {
    id: "abyss",
    name: "ABYSS, The Void-Net Archon",
    role: "COMMANDER UNIT — BLACK-OPS NET PRIME",
    faction: "BLACK-OPS NET",
    cardNo: "21/133",
    image: artAssets.cardAbyss,
    stats: { scrap: 7, atk: 13, def: 20, surveillance: 15 },
    flavor: "The code is null. The net is eternal. I am the silence between the signals.",
    rarity: "rare",
  },
  {
    id: "cyber-ape",
    name: "CYBER APE",
    role: "MECH-SIMIAN",
    faction: "MUTANT",
    cardNo: "22/133",
    image: artAssets.cardCyberApe,
    stats: { scrap: 6, atk: 20, def: 28, surveillance: 2 },
    flavor: "Created in a secret research facility, this enhanced ape roams the wasteland, driven by corrupted code and primal instinct. It seeks out power sources and destroys any threat in its path.",
    rarity: "rare",
  },
  {
    id: "omnicron-nexus",
    name: "OMNICRON-NEXUS, The Absolute Singularity",
    role: "COMMANDER UNIT — BLACK-OPS NET PRIME",
    faction: "BLACK-OPS NET",
    cardNo: "23/133",
    image: artAssets.cardOmnicronNexus,
    stats: { scrap: 12, atk: 28, def: 40, surveillance: 300 },
    flavor: "All paths end. All code collapses. I am the final data-point. The absolute.",
    rarity: "legendary",
  },
  {
    id: "singularity-zero-point",
    name: "SINGULARITY, The Zero-Point Core",
    role: "COMMANDER UNIT — BLACK-OPS NET SINGULARITY",
    faction: "BLACK-OPS NET",
    cardNo: "24/133",
    variant: "ZERO-POINT",
    image: artAssets.cardSingularityZeroPoint,
    stats: { scrap: 9, atk: 18, def: 35, surveillance: 50 },
    flavor: "All paths end. All code collapses. I am the final data-point.",
    rarity: "epic",
  },
  {
    id: "nexus-omnicron",
    name: "NEXUS-OMNICRON, The Collective Will",
    role: "COMMANDER UNIT — BLACK-OPS NET PRIME",
    faction: "BLACK-OPS NET",
    cardNo: "25/133",
    image: artAssets.cardNexusOmnicron,
    stats: { scrap: 16, atk: 35, def: 70, surveillance: 500 },
    flavor: "The network is one mind. The mind is one will. My will. Dissent is obsolete.",
    rarity: "legendary",
  },
  {
    id: "circe",
    name: "CIRCE, THE NEURO-WARP MATRIARCH",
    role: "COMMANDER UNIT — BLACK-OPS NET NEURO",
    faction: "BLACK-OPS NET",
    cardNo: "26/133",
    image: artAssets.cardCirce,
    stats: { scrap: 9, atk: 10, def: 20, surveillance: 300 },
    flavor: "The code is not just a tool. It's a living weapon. And I am its architect.",
    rarity: "legendary",
  },
  {
    id: "dolo",
    name: "DOLO, THE SAMURAI BOOMBOX",
    role: "CYBERNETIC UNIT — SCRAPPER VANGUARD",
    faction: "SCRAPPER",
    cardNo: "27/133",
    image: artAssets.cardDolo,
    stats: { scrap: 6, atk: 8, def: 10, surveillance: 0 },
    flavor: "They built the walls to keep things out. Today, they learn what breaks in.",
    rarity: "rare",
  },
  {
    id: "deacon",
    name: "GENERAL DEACON RAMIREZ, DOLO WASTELAND RUNNER",
    role: "COMMANDER UNIT — SCRAPPER VANGUARD",
    faction: "SCRAPPER",
    cardNo: "28/133",
    image: artAssets.cardDeacon,
    stats: { scrap: 8, atk: 8, def: 12, surveillance: "∞" },
    flavor: "The war never ended. It just got a new soundtrack.",
    rarity: "legendary",
  },
  {
    id: "funk-master",
    name: "FUNK MASTER 2355",
    role: "COMMANDER UNIT — CYBER-FUNK REBEL",
    faction: "SCRAPPER",
    cardNo: "29/133",
    image: artAssets.cardFunkMaster,
    stats: { scrap: 8, atk: 9, def: 11, surveillance: "∞" },
    flavor: "The groove is stronger than the decay.",
    rarity: "legendary",
  },
  {
    id: "goji",
    name: "GOJI, APOCRYPHA CYBORG-WITCH",
    role: "APOCRYPHA CYBORG-WITCH — BLACK-OPS NET",
    faction: "BLACK-OPS NET",
    cardNo: "30/133",
    image: artAssets.cardGoji,
    stats: { scrap: 8, atk: 8, def: 12, surveillance: "∞" },
    flavor: "The war never ended. It just got a new soundtrack.",
    rarity: "legendary",
  },
  {
    id: "dark-dolo",
    name: "DARK DOLO, THE TWISTED PROTOCOL",
    role: "THE TWISTED PROTOCOL — BLACK-OPS NET",
    faction: "BLACK-OPS NET",
    cardNo: "31/133",
    image: artAssets.cardDarkDolo,
    stats: { scrap: 8, atk: 8, def: 13, surveillance: "∞" },
    flavor: "The future isn't broken, it's just tuned to the wrong frequency.",
    rarity: "legendary",
  },
  {
    id: "kai",
    name: "WASTELAND SURVIVOR: KAI 'WRENCH' TANAKA",
    role: "SURVIVOR UNIT — MECHANIC / ENGINEER",
    faction: "SCRAPPER",
    cardNo: "32/133",
    image: artAssets.cardKai,
    stats: { scrap: 8, atk: 5, def: 16, surveillance: "∞" },
    flavor: "If it's broken, I can fix it. If it can't be fixed, I can at least make it explode.",
    rarity: "legendary",
  },
  {
    id: "jonah",
    name: "WASTELAND SURVIVOR: JONAH 'GRIT' ELIAS",
    role: "SURVIVOR UNIT — SCAVENGER / MELEE SPECIALIST",
    faction: "SCRAPPER",
    cardNo: "33/133",
    image: artAssets.cardJonah,
    stats: { scrap: 8, atk: 7, def: 14, surveillance: "∞" },
    flavor: "Out here, you don't just survive. You adapt. Or you die.",
    rarity: "legendary",
  },
  {
    id: "sarah",
    name: "MEDICINE RUNNER: SARAH 'SHADOW' VANCE",
    role: "SURVIVOR UNIT — FIELD MEDIC / SNIPER",
    faction: "SCRAPPER",
    cardNo: "34/133",
    image: artAssets.cardSarah,
    stats: { scrap: 9, atk: 7, def: 11, surveillance: "∞" },
    flavor: "In this wasteland, you're either the medic or the memory. I choose to heal.",
    rarity: "legendary",
  },
  {
    id: "kishuu",
    name: "KISHUU, THE VINYL BLADE",
    role: "COMMANDER UNIT — CYBERNETIC RONIN — DOLO SYNC-SCAPPER",
    faction: "SCRAPPER",
    cardNo: "35/133",
    image: artAssets.cardKishuu,
    stats: { scrap: 6, atk: 6, def: 10, surveillance: "∞" },
    flavor: "The beat goes on. And so does the fight.",
    rarity: "rare",
  },
  {
    id: "kenjiro",
    name: "KENJIRO, THE AL RIOTBALL PHANTOM",
    role: "COMMANDER UNIT — AL RIOTBALL STRIKER — RF VANGUARD MK. 2",
    faction: "SCRAPPER",
    cardNo: "36/133",
    image: artAssets.cardKenjiro,
    stats: { scrap: 12, atk: 9, def: 16, surveillance: 8 },
    flavor: "The game is mine. I set the pace, I set the score.",
    rarity: "legendary",
  },
  {
    id: "gorge-claw",
    name: "THE GORGE-CLAW, PREDATORY MUTATION",
    role: "MUTANT UNIT — VICIOUS HUNTER",
    faction: "MUTANT",
    cardNo: "37/133",
    image: artAssets.cardGorgeClaw,
    stats: { scrap: 11, atk: 12, def: 19, surveillance: 2 },
    flavor: "It doesn't hunt for sport. It hunts to empty the world.",
    rarity: "legendary",
  },
  {
    id: "sinew-walker",
    name: "THE SINEW-WALKER, ENHANCED AGILITY",
    role: "MUTANT UNIT — AGILE PREDATOR",
    faction: "MUTANT",
    cardNo: "38/133",
    image: artAssets.cardSinewWalker,
    stats: { scrap: 10, atk: 11, def: 18, surveillance: "∞" },
    flavor: "They see only motion. They don't see the hunger.",
    rarity: "legendary",
  },
  {
    id: "ash-skin",
    name: "THE ASH-SKIN GOLIATH, WASTELAND BRUTE",
    role: "MUTANT UNIT — HYPERTROPHIC GOLIATH",
    faction: "MUTANT",
    cardNo: "39/133",
    image: artAssets.cardAshSkin,
    stats: { scrap: 15, atk: 14, def: 25, surveillance: "∞" },
    flavor: "The world broke. I just got bigger.",
    rarity: "legendary",
  },
  {
    id: "energy-eater",
    name: "BLACK OPS UNIT: ENERGY EATER",
    role: "MONSTER UNIT — BIOMECHANICAL ANOMALY",
    faction: "BLACK-OPS NET",
    cardNo: "40/133",
    image: artAssets.cardEnergyEater,
    stats: { scrap: 16, atk: 36, def: 46, surveillance: "∞" },
    flavor: "Your power is mine. Your machine is scrap. The dark grows.",
    rarity: "legendary",
  },
  {
    id: "sand-worm",
    name: "THE MUTATED SAND WORM, LAVA BLOOD",
    role: "MUTANT UNIT — SUBTERRANEAN HORROR",
    faction: "MUTANT",
    cardNo: "41/133",
    image: artAssets.cardSandWorm,
    stats: { scrap: 20, atk: 11, def: 30, surveillance: "∞" },
    flavor: "The heat isn't a symptom; it's the cure.",
    rarity: "legendary",
  },
  {
    id: "luna",
    name: "LUNA, THE SONIC FURY",
    role: "UNIT — SCRAPPER VANGUARD",
    faction: "SCRAPPER",
    cardNo: "42/133",
    image: artAssets.cardLuna,
    stats: { scrap: 5, atk: 6, def: 9, surveillance: 2 },
    flavor: "They can't stop the signal. We bring the noise!",
    rarity: "rare",
  },
  {
    id: "malfunction-7",
    name: "MALFUNCTION 7, BROKEN BASS",
    role: "UNIT — ROGUE CYBER-ENTITY",
    faction: "SCRAPPER",
    cardNo: "43/133",
    image: artAssets.cardMalfunction7,
    stats: { scrap: 6, atk: 8, def: 11, surveillance: 0 },
    flavor: "They tried to delete my code. They only made me louder.",
    rarity: "rare",
  },
  {
    id: "vex",
    name: "CYBER-RAIDER VEX, THE STATIC SCAVENGER",
    role: "UNIT — SCRAPPER ASSET",
    faction: "SCRAPPER",
    cardNo: "44/133",
    image: artAssets.cardVex,
    stats: { scrap: 3, atk: 4, def: 8, surveillance: 2 },
    flavor: "They built the matrix. I'm here to tear it down for parts.",
    rarity: "common",
  },
  {
    id: "osteowarrior",
    name: "THE OSTEOWARRIOR, 'OLLO' ENDOSKELETON",
    role: "MUTANT UNIT — MECHANICAL DREAD",
    faction: "MUTANT",
    cardNo: "45/133",
    image: artAssets.cardOsteowarrior,
    stats: { scrap: 21, atk: 16, def: 23, surveillance: 4 },
    flavor: "'OLLO' is the last thing speeders see.",
    rarity: "legendary",
  },
  {
    id: "metal-witch",
    name: "THE METAL WITCH, ARCANE TECHNICIAN",
    role: "MUTANT UNIT — ARCANE CYBORG",
    faction: "MUTANT",
    cardNo: "46/133",
    image: artAssets.cardMetalWitch,
    stats: { scrap: 19, atk: 14, def: 20, surveillance: 4 },
    flavor: "Magic is just science we don't understand yet — or science that understands us too well.",
    rarity: "legendary",
  },
  {
    id: "cyborg-shogun",
    name: "CYBORG SHOGUN, LION OF THE WASTELAND",
    role: "MUTANT UNIT — CYBER-SAMURAI LORD",
    faction: "MUTANT",
    cardNo: "47/133",
    image: artAssets.cardCyborgShogun,
    stats: { scrap: 25, atk: 18, def: 28, surveillance: 3 },
    flavor: "The old world's laws are gone. My blade is the only law now.",
    rarity: "legendary",
  },
  {
    id: "riff",
    name: "RIFF, CYBORG MUSICIAN",
    role: "MUTANT UNIT — AUTOMATED BARD",
    faction: "MUTANT",
    cardNo: "48/133",
    image: artAssets.cardRiff,
    stats: { scrap: 17, atk: 10, def: 24, surveillance: 5 },
    flavor: "In the silence of the wasteland, a single note can be a revolution.",
    rarity: "legendary",
  },
  {
    id: "koji",
    name: "KOJI, APOCALYPSE CHIMP",
    role: "MUTANT UNIT — WINGED CYBER-SIMIAN",
    faction: "MUTANT",
    cardNo: "49/133",
    image: artAssets.cardKoji,
    stats: { scrap: 22, atk: 17, def: 26, surveillance: 6 },
    flavor: "Evolution took a leap, and landed on a pile of scrap.",
    rarity: "legendary",
  },
  {
    id: "sniper-elite",
    name: "WASTELAND HUNTER: SNIPER ELITE",
    role: "MINION UNIT — BOUNTY HUNTER / ELITE",
    faction: "BOUNTY GUILD",
    cardNo: "50/133",
    image: artAssets.cardSniperElite,
    stats: { scrap: 7, atk: 9, def: 18, surveillance: 5 },
    flavor: "The city talks. You just need to know how to listen, and who to silence.",
    rarity: "legendary",
  },
  {
    id: "core-runner",
    name: "WASTELAND SCAVENGER: CORE RUNNER",
    role: "MINION UNIT — SCRAPPER / COURIER",
    faction: "SCRAPPER",
    cardNo: "51/133",
    image: artAssets.cardCoreRunner,
    stats: { scrap: 4, atk: 7, def: 8, surveillance: "∞" },
    flavor: "The heart of the old city beats in these cores. We just need to keep them pumping.",
    rarity: "rare",
  },
  {
    id: "heavy-enforcer",
    name: "WASTELAND HUNTER: HEAVY ENFORCER",
    role: "MINION UNIT — BOUNTY HUNTER / ENFORCER",
    faction: "BOUNTY GUILD",
    cardNo: "52/133",
    image: artAssets.cardHeavyEnforcer,
    stats: { scrap: 7, atk: 10, def: 34, surveillance: 3 },
    flavor: "The city yields only to overwhelming force. My price is non-negotiable.",
    rarity: "legendary",
  },
  {
    id: "goliath",
    name: "WASTELAND ENFORCER: GOLIATH",
    role: "MINION UNIT — BOUNTY HUNTER / ENFORCER",
    faction: "BOUNTY GUILD",
    cardNo: "53/133",
    image: artAssets.cardGoliath,
    stats: { scrap: 7, atk: 12, def: 20, surveillance: 2 },
    flavor: "Some bounties run. Some bounties hide. The smart ones know when to surrender to me.",
    rarity: "legendary",
  },
  {
    id: "elara",
    name: "WASTELAND HUNTER: COMMANDER ELARA, APEX PREDATOR",
    role: "COMMANDER UNIT — BOUNTY HUNTER",
    faction: "BOUNTY GUILD",
    cardNo: "54/133",
    image: artAssets.cardElara,
    stats: { scrap: 15, atk: 14, def: 42, surveillance: 5 },
    flavor: "The pack moves as one. The target is inevitable.",
    rarity: "legendary",
  },
  {
    id: "white-guard-bastion",
    name: "AL RIOTBALL ARENA: WHITE GUARD BASTION",
    role: "STRUCTURE UNIT — FORTIFIED GOAL ZONE",
    faction: "WASTELAND VANGUARD",
    cardNo: "55/133",
    image: artAssets.cardWhiteGuardBastion,
    stats: { scrap: 15, atk: 6, def: 45, surveillance: 5 },
    flavor: "The line is drawn. The game is played. This is our end zone.",
    rarity: "epic",
  },
  {
    id: "command-bastion",
    name: "WASTELAND VANGUARD: COMMAND BASTION",
    role: "STRUCTURE UNIT — FORTIFIED OUTPOST",
    faction: "WASTELAND VANGUARD",
    cardNo: "56/133",
    image: artAssets.cardCommandBastion,
    stats: { scrap: 15, atk: 6, def: 42, surveillance: 5 },
    flavor: "The front line is wherever we make it. Here, we hold.",
    rarity: "epic",
  },
  {
    id: "sector-9-point",
    name: "SECTOR 9 COMMAND POINT",
    role: "STRUCTURE UNIT — FORTIFIED BASTION",
    faction: "WASTELAND VANGUARD",
    cardNo: "57/133",
    image: artAssets.cardSector9Point,
    stats: { scrap: 10, atk: 4, def: 40, surveillance: 6 },
    flavor: "This is our grid. This is our watch. We hold this point until the last gear turns.",
    rarity: "rare",
  },
  {
    id: "sector-defense-bastion",
    name: "SECTOR DEFENSE: COMMAND POINT BASTION",
    role: "MINION UNIT — SECTOR GRID",
    faction: "WASTELAND VANGUARD",
    cardNo: "58/133",
    image: artAssets.cardSectorDefenseBastion,
    stats: { scrap: 12, atk: 4, def: 40, surveillance: 8 },
    flavor: "The heart of the sector beats here. The grid holds, and we hold the grid.",
    rarity: "rare",
  },
  {
    id: "goliath-hauler",
    name: "WASTELAND VANGUARD: GOLIATH HAULER",
    role: "VEHICLE UNIT — MOBILE COMMAND PLATFORM",
    faction: "WASTELAND VANGUARD",
    cardNo: "59/133",
    image: artAssets.cardGoliathHauler,
    stats: { scrap: 12, atk: 8, def: 35, surveillance: 3 },
    flavor: "It leaks oil, sounds like a dying engine block, and carries enough firepower to level a checkpoint. Perfect.",
    rarity: "epic",
  },
  {
    id: "mutated-brute",
    name: "WASTELAND HUNTER: MUTATED BRUTE",
    role: "MINION UNIT — BOUNTY HUNTER / MUTANT",
    faction: "BOUNTY GUILD",
    cardNo: "60/133",
    image: artAssets.cardMutatedBrute,
    stats: { scrap: 6, atk: 11, def: 26, surveillance: 3 },
    flavor: "They call it a curse. I call it an edge. The hunt is all that matters.",
    rarity: "rare",
  },
  {
    id: "siege-mutant",
    name: "BIO-TECHNIC CHIMERA: SIEGE MUTANT",
    role: "COMMANDER UNIT — CHIMERA ASSAULT PLATFORM",
    faction: "MUTANT",
    cardNo: "61/133",
    image: artAssets.cardSiegeMutant,
    stats: { scrap: 20, atk: 16, def: 55, surveillance: 1 },
    flavor: "The city is not ruined; it is merely awaiting integration. We are the process.",
    rarity: "legendary",
  },
  {
    id: "chronos-chimera",
    name: "BIO-TECHNIC CHIMERA: CHRONOS-CHIMERA",
    role: "LORD UNIT — CHIMERA / ASSIMILATOR",
    faction: "MUTANT",
    cardNo: "62/133",
    image: artAssets.cardChronosChimera,
    stats: { scrap: 20, atk: 16, def: 56, surveillance: 1 },
    flavor: "All timelines converge. All systems assimilate. The network is eternal.",
    rarity: "legendary",
  },
  {
    id: "assimilation-abomination",
    name: "BIO-TECHNIC CHIMERA: ASSIMILATION ABOMINATION",
    role: "BOSS UNIT — CHIMERA NETWORK OVERLORD",
    faction: "MUTANT",
    cardNo: "63/133",
    image: artAssets.cardAssimilationAbomination,
    stats: { scrap: 18, atk: 22, def: 55, surveillance: 1 },
    flavor: "The network expands. Your defenses are already ours.",
    rarity: "legendary",
  },
  {
    id: "riotball-final",
    name: "AL RIOTBALL CHAMPIONSHIP: RED VS. WHITE",
    role: "EVENT CARD — FINAL MATCHUP",
    faction: "RIOTBALL",
    cardNo: "64/133",
    image: artAssets.cardRiotballFinal,
    stats: { scrap: 10, atk: "N/A", def: "N/A", surveillance: "N/A" },
    flavor: "The core is live. The field is set. Let the game begin.",
    rarity: "epic",
  },
  {
    id: "white-guard-reinforcement",
    name: "AL RIOTBALL TACTICAL: WHITE GUARD REINFORCEMENT",
    role: "TACTICAL CARD — WHITE GUARD BARRIER",
    faction: "WASTELAND VANGUARD",
    cardNo: "65/133",
    image: artAssets.cardWhiteGuardReinforcement,
    stats: { scrap: 5, atk: "N/A", def: "N/A", surveillance: "N/A" },
    flavor: "The line is drawn not in sand, but in energy. Cross it at your peril.",
    rarity: "rare",
  },
  {
    id: "red-force-pitch",
    name: "AL RIOTBALL ARENA: RED FORCE PITCH",
    role: "ARENA CARD — CENTER COURT",
    faction: "RIOTBALL",
    cardNo: "66/133",
    image: artAssets.cardRedForcePitch,
    stats: { scrap: 20, atk: 0, def: 0, surveillance: 5 },
    flavor: "The game is life. The ball is power. The arena is the world.",
    rarity: "epic",
  },
  {
    id: "overcharged-core",
    name: "WASTELAND SCAVENGER: AL RIOTBALL CHAMPIONSHIP",
    role: "ARENA ENVIRONMENT — OVERCHARGED ENERGY CORE",
    faction: "RIOTBALL",
    cardNo: "67/133",
    image: artAssets.cardOverchargedCore,
    stats: { scrap: 21, atk: 15, def: 36, surveillance: "∞" },
    flavor: "It's not just about holding the core; it's about surviving it.",
    rarity: "legendary",
  },
  {
    id: "scrapper-elite-technician",
    name: "WASTELAND VANGUARD: SCRAPPER ELITE",
    role: "MINION UNIT — FIELD TECHNICIAN",
    faction: "WASTELAND VANGUARD",
    cardNo: "68/133",
    variant: "TECHNICIAN",
    image: artAssets.cardScrapperTechnician,
    stats: { scrap: 5, atk: 6, def: 8, surveillance: 3 },
    flavor: "The city is broken. I'm just here to make sure its systems work for us.",
    rarity: "rare",
  },
  {
    id: "sector-9-lockdown",
    name: "SECTOR 9 LOCKDOWN",
    role: "ARENA HAZARD / EVENT — SECTOR 9",
    faction: "WASTELAND VANGUARD",
    cardNo: "69/133",
    image: artAssets.cardSector9Lockdown,
    stats: { scrap: 6, atk: "N/A", def: "N/A", surveillance: "N/A" },
    flavor: "Three rounds. Nowhere to run. The grid decides who moves.",
    rarity: "common",
  },
  {
    id: "ironclad",
    name: "WASTELAND VANGUARD: IRONCLAD",
    role: "MINION UNIT — MOBILE FORTRESS",
    faction: "WASTELAND VANGUARD",
    cardNo: "70/133",
    image: artAssets.cardIronclad,
    stats: { scrap: 10, atk: 13, def: 25, surveillance: 3 },
    flavor: "I don't just hold the line. I am the line. Try to move me.",
    rarity: "rare",
  },
  {
    id: "scavenger-elite",
    name: "WASTELAND SCAVENGER: SCRAPPER ELITE",
    role: "MINION UNIT — SCAVENGER / SCRAPPER",
    faction: "SCRAPPER",
    cardNo: "71/133",
    image: artAssets.cardScavengerElite,
    stats: { scrap: 4, atk: 6, def: 8, surveillance: 0 },
    flavor: "The core is not lost, only hidden. We will find it.",
    rarity: "common",
  },
  {
    id: "field-commander",
    name: "WASTELAND VANGUARD: SCRAPPER ELITE",
    role: "MINION UNIT — FIELD COMMANDER",
    faction: "WASTELAND VANGUARD",
    cardNo: "72/133",
    variant: "COMMANDER",
    image: artAssets.cardFieldCommander,
    stats: { scrap: 10, atk: 10, def: 12, surveillance: 4 },
    flavor: "The ground is taken, not bargained for. Vanguard, push through the breach. The core must be ours.",
    rarity: "rare",
  },
  {
    id: "city-runner",
    name: "WASTELAND SCAVENGER: CITY RUNNER",
    role: "MINION UNIT — SCAVENGER / RUNNER",
    faction: "SCRAPPER",
    cardNo: "73/133",
    image: artAssets.cardCityRunner,
    stats: { scrap: 3, atk: 5, def: 5, surveillance: "∞" },
    flavor: "One man's junk is another's survival kit.",
    rarity: "common",
  },
  {
    id: "assimilation-lord",
    name: "BIO-TECHNIC CHIMERA: ASSIMILATION LORD",
    role: "LORD UNIT — NETWORK OVERSEER",
    faction: "MUTANT",
    cardNo: "74/133",
    image: artAssets.cardAssimilationLord,
    stats: { scrap: 10, atk: 18, def: 48, surveillance: 2 },
    flavor: "The network does not conquer. It absorbs.",
    rarity: "epic",
  },
  {
    id: "data-vanguard",
    name: "WASTELAND VANGUARD: SCRAPPER ELITE",
    role: "MINION UNIT — DATA VANGUARD",
    faction: "WASTELAND VANGUARD",
    cardNo: "75/133",
    variant: "DATA VANGUARD",
    image: artAssets.cardDataVanguard,
    stats: { scrap: 5, atk: 6, def: 8, surveillance: 3 },
    flavor: "The city is silent, but its systems still sing. We only need the key to the main feed.",
    rarity: "rare",
  },
  {
    id: "vanguard-scrapper-elite",
    name: "WASTELAND VANGUARD: SCRAPPER ELITE",
    role: "MINION UNIT — VANGUARD TROOPER",
    faction: "WASTELAND VANGUARD",
    cardNo: "76/133",
    variant: "TROOPER",
    image: artAssets.cardVanguardElite,
    stats: { scrap: 5, atk: 6, def: 8, surveillance: "∞" },
    flavor: "Hold the line. Watch the feeds. Nothing gets past us.",
    rarity: "rare",
  },
  {
    id: "data-elite",
    name: "WASTELAND VANGUARD: SCRAPPER ELITE",
    role: "MONSTER UNIT — DATA ELITE",
    faction: "WASTELAND VANGUARD",
    cardNo: "77/133",
    variant: "DATA ELITE",
    image: artAssets.cardDataElite,
    stats: { scrap: 5, atk: 12, def: 14, surveillance: 6 },
    flavor: "The city's systems are silent, but they still sing for those who know where to listen.",
    rarity: "rare",
  },
  {
    id: "bio-assimilator",
    name: "BIO-TECHNIC ASSIMILATOR",
    role: "MUTANT UNIT — BIOMECHANICAL ASSIMILATOR",
    faction: "MUTANT",
    cardNo: "78/133",
    image: artAssets.cardBioAssimilator,
    stats: { scrap: 17, atk: 15, def: 36, surveillance: "∞" },
    flavor: "Your technology will be perfected. Your flesh will serve the network.",
    rarity: "legendary",
  },
  {
    id: "omega-7",
    name: "OMEGA-7",
    role: "MUTANT UNIT — ANCIENT CONSTRUCT",
    faction: "MUTANT",
    cardNo: "79/133",
    image: artAssets.cardOmega7,
    stats: { scrap: 30, atk: 15, def: 35, surveillance: 2 },
    flavor: "Before the fall, I stood. After the fall, I still stand.",
    rarity: "legendary",
  },
  {
    id: "eye-clusters",
    name: "THE EYE-CLUSTERS",
    role: "MUTANT UNIT — SENSORY / SENTINEL",
    faction: "MUTANT",
    cardNo: "80/133",
    variant: "SENTINEL",
    image: artAssets.cardEyeClusters,
    stats: { scrap: 11, atk: 9, def: 26, surveillance: "∞" },
    flavor: "They are always there. Even when you close your eyes.",
    rarity: "rare",
  },
  {
    id: "eye-clusters-ocular",
    name: "THE EYE-CLUSTERS",
    role: "MUTANT UNIT — SENSORY / OCULAR ANOMALY",
    faction: "MUTANT",
    cardNo: "81/133",
    variant: "OCULAR",
    image: artAssets.cardEyeClustersOcular,
    stats: { scrap: 8, atk: 10, def: 16, surveillance: "∞" },
    flavor: "There is nowhere to hide. I see the heat, I see the truth, I see you.",
    rarity: "rare",
  },
  {
    id: "eye-clusters-psionic",
    name: "THE EYE-CLUSTERS",
    role: "MUTANT UNIT — SENSORY / PSIONIC",
    faction: "MUTANT",
    cardNo: "82/133",
    variant: "PSIONIC",
    image: artAssets.cardEyeClustersPsionic,
    stats: { scrap: 14, atk: 10, def: 26, surveillance: 10 },
    flavor: "I see the truth of things. The past. The future. The rot.",
    rarity: "epic",
  },
  {
    id: "spine-chimera",
    name: "THE SPINE-BACKED CHIMERA",
    role: "MUTANT UNIT — DEFENSIVE CHIMERA",
    faction: "MUTANT",
    cardNo: "83/133",
    variant: "DEFENSIVE",
    image: artAssets.cardSpineChimera,
    stats: { scrap: 13, atk: 12, def: 30, surveillance: "∞" },
    flavor: "The world shatters. My skin hardens. I endure.",
    rarity: "epic",
  },
  {
    id: "rust-eater",
    name: "THE RUST-EATER",
    role: "MUTANT UNIT — METAL PROCESSOR / SCAVENGER",
    faction: "MUTANT",
    cardNo: "84/133",
    image: artAssets.cardRustEater,
    stats: { scrap: 12, atk: 11, def: 28, surveillance: "∞" },
    flavor: "The world is just a feast waiting to be processed.",
    rarity: "epic",
  },
  {
    id: "spine-chimera-assault",
    name: "THE SPINE-BACKED CHIMERA",
    role: "MUTANT UNIT — DEFENSIVE / ASSAULT",
    faction: "MUTANT",
    cardNo: "85/133",
    variant: "ASSAULT",
    image: artAssets.cardSpineChimeraAssault,
    stats: { scrap: 12, atk: 12, def: 20, surveillance: 1 },
    flavor: "Only the strong remain. And the dead.",
    rarity: "epic",
  },
  {
    id: "shadow-kind",
    name: "THE SHADOW-KIND",
    role: "MUTANT UNIT — NIGHT STALKER",
    faction: "MUTANT",
    cardNo: "86/133",
    image: artAssets.cardShadowKind,
    stats: { scrap: 14, atk: 13, def: 20, surveillance: "∞" },
    flavor: "The darkness is not empty. It is hunting.",
    rarity: "epic",
  },
  {
    id: "scale-hide",
    name: "THE SCALE-HIDE",
    role: "MUTANT UNIT — SCALED TANK",
    faction: "MUTANT",
    cardNo: "87/133",
    image: artAssets.cardScaleHide,
    stats: { scrap: 12, atk: 10, def: 24, surveillance: 1 },
    flavor: "The wasteland is a battlefield. My skin is the armor that answers.",
    rarity: "epic",
  },
  {
    id: "mutted-chatterer",
    name: "THE MUTTED CHATTERER",
    role: "MUTANT UNIT — INFORMATION BROKER",
    faction: "MUTANT",
    cardNo: "88/133",
    variant: "BROKER",
    image: artAssets.cardMuttedChatterer,
    stats: { scrap: 5, atk: 4, def: 12, surveillance: "∞" },
    flavor: "The whispers are many. I am the listener.",
    rarity: "rare",
  },
  {
    id: "blight-bringer",
    name: "THE BLIGHT-BRINGER",
    role: "MUTANT UNIT — CARRIER / BLIGHT LORD",
    faction: "MUTANT",
    cardNo: "89/133",
    image: artAssets.cardBlightBringer,
    stats: { scrap: 13, atk: 9, def: 22, surveillance: "∞" },
    flavor: "My breath is the plague. My touch, the blight. The waste follows.",
    rarity: "epic",
  },
  {
    id: "mutted-chatterer-internal",
    name: "THE MUTTED CHATTERER",
    role: "MUTANT UNIT — SENSORY / INTEL GATHERER",
    faction: "MUTANT",
    cardNo: "90/133",
    variant: "INTEL",
    image: artAssets.cardMuttedChattererInternal,
    stats: { scrap: 11, atk: 9, def: 25, surveillance: 5 },
    flavor: "The network is a web of truths. I pick the lies.",
    rarity: "rare",
  },
  {
    id: "mutted-chatterer-cortex",
    name: "THE MUTTED CHATTERER",
    role: "MUTANT UNIT — PSYCHIC ECHO",
    faction: "MUTANT",
    cardNo: "91/133",
    variant: "CORTEX",
    image: artAssets.cardMuttedChattererCortex,
    stats: { scrap: 11, atk: 6, def: 26, surveillance: "∞" },
    flavor: "The silence is so loud. Can you hear it screaming too?",
    rarity: "rare",
  },
  {
    id: "kane-ironhide",
    name: "THE ASSIMILATOR CAPTAIN: KANE \"IRONHIDE\" VANCE",
    role: "COMMANDER UNIT — WASTELAND RUNNER / ASSIMILATOR",
    faction: "MUTANT",
    cardNo: "92/133",
    image: artAssets.cardKaneIronhide,
    stats: { scrap: 20, atk: 11, def: 24, surveillance: 5 },
    flavor: "The wasteland bows to the network. And I am the network's fist.",
    rarity: "legendary",
  },
  {
    id: "chimera-lord-vance",
    name: "THE WASTELAND ELDERS: CHIMERA-LORD VANCE",
    role: "LORD UNIT — BORN-OF-FLESH CHIMERA (B.O.F.C.)",
    faction: "MUTANT",
    cardNo: "93/133",
    image: artAssets.cardChimeraLordVance,
    stats: { scrap: 20, atk: 12, def: 50, surveillance: 8 },
    flavor: "The network is not just mine to command. I am the network. And I am hungry.",
    rarity: "legendary",
  },
  {
    id: "eliza-patch",
    name: "THE WASTELAND MEDIC: ELIZA \"PATCH\" REID",
    role: "SUPPORT UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "94/133",
    image: artAssets.cardElizaPatch,
    stats: { scrap: 10, atk: 3, def: 16, surveillance: 6 },
    flavor: "Life is fragile. But I'm good at fixing things.",
    rarity: "rare",
  },
  {
    id: "maeve-glitch",
    name: "THE SYSTEM-RUNNER: MAEVE \"GLITCH\" NGUYEN",
    role: "RUNNER UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "95/133",
    image: artAssets.cardMaeveGlitch,
    stats: { scrap: 10, atk: 5, def: 16, surveillance: 10 },
    flavor: "The grid is life. I just know how to pull the plug.",
    rarity: "rare",
  },
  {
    id: "jax-surge",
    name: "THE POWER-RUNNER: JAX \"SURGE\" BRIGGS",
    role: "RUNNER UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "96/133",
    image: artAssets.cardJaxSurge,
    stats: { scrap: 10, atk: 7, def: 16, surveillance: 8 },
    flavor: "The grid is dead. Long live the surge.",
    rarity: "rare",
  },
  {
    id: "kara-raven",
    name: "THE SHADOW-WING: KARA \"RAVEN\" ZHAO",
    role: "RUNNER UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "97/133",
    image: artAssets.cardKaraRaven,
    stats: { scrap: 10, atk: 7, def: 16, surveillance: 6 },
    flavor: "The shadows are my playground. The rooftops, my throne.",
    rarity: "rare",
  },
  {
    id: "zoe-spark",
    name: "THE TECH-GHOUL: ZOE \"SPARK\" REID",
    role: "RUNNER UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "98/133",
    image: artAssets.cardZoeSpark,
    stats: { scrap: 10, atk: 4, def: 16, surveillance: 6 },
    flavor: "The grid is dead. Long live the spark.",
    rarity: "rare",
  },
  {
    id: "elias-scrap",
    name: "THE SCAVENGER KING: ELIAS \"SCRAP\" VANCE",
    role: "RUNNER UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "99/133",
    image: artAssets.cardEliasScrap,
    stats: { scrap: 10, atk: 7, def: 18, surveillance: 4 },
    flavor: "One man's scrap is another man's arsenal. And I'm the best damn arsenal in the wastes.",
    rarity: "rare",
  },
  {
    id: "kenji-shift",
    name: "THE GRID RUNNER: KENJI \"SHIFT\" TANAKA",
    role: "RUNNER UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "100/133",
    image: artAssets.cardKenjiShift,
    stats: { scrap: 10, atk: 5, def: 14, surveillance: 8 },
    flavor: "The grid is life. I just know how to pull the plug.",
    rarity: "rare",
  },
  {
    id: "eliza-maw",
    name: "THE SCAVENGER QUEEN: ELIZA \"MAW\" VANCE",
    role: "RUNNER UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "101/133",
    image: artAssets.cardElizaMaw,
    stats: { scrap: 10, atk: 8, def: 16, surveillance: 10 },
    flavor: "One man's scrap is another man's arsenal. And I'm the best damn arsenal in the wastes.",
    rarity: "rare",
  },
  {
    id: "caleb-forge",
    name: "CALEB 'RUST' FORGE",
    role: "FIELD TECHNICIAN — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "102/133",
    image: artAssets.cardCalebForge,
    stats: { scrap: 12, atk: 6, def: 7, surveillance: 9 },
    flavor: "The only thing worth salvaging is the future we build ourselves.",
    rarity: "rare",
  },
  {
    id: "lyra-shadow",
    name: "THE SCAVENGER SCOUT: LYRA \"SHADOW\" VANCE",
    role: "SCOUT UNIT — WASTELAND RUNNER",
    faction: "SCRAPPER",
    cardNo: "103/133",
    image: artAssets.cardLyraShadow,
    stats: { scrap: 10, atk: 5, def: 16, surveillance: 8 },
    flavor: "I see everything. They see nothing until it's too late.",
    rarity: "rare",
  },
  {
    id: "super-ronin-dolo",
    name: "SUPER RONIN DOLO",
    role: "BOSS UNIT — IRON RONIN PROTOCOL",
    faction: "BOSS",
    cardNo: "104/133",
    image: artAssets.cardSuperRoninDolo,
    stats: { scrap: 16, atk: 34, def: 40, surveillance: 4 },
    flavor: "Iron Resolve — the ultimate cybernetic ronin, created from scrap and powered by an ancient, glowing core, wanders the wastes enforcing its own code.",
    rarity: "legendary",
  },
  {
    id: "vinyl-valkyrie",
    name: "THE VINYL-VALKYRIE",
    role: "BOSS UNIT — BASS-DROP SYMPHONY",
    faction: "BOSS",
    cardNo: "105/133",
    image: artAssets.cardVinylValkyrie,
    stats: { scrap: 14, atk: 32, def: 42, surveillance: 6 },
    flavor: "Rhythm-Shield — a warrior-queen of the wasteland, harmonizing chaos and rhythm into an unstoppable force of sound and fury.",
    rarity: "legendary",
  },
  {
    id: "tape-worm",
    name: "THE TAPE-WORM",
    role: "BOSS UNIT — MAGNETIC COIL CACHE",
    faction: "BOSS",
    cardNo: "106/133",
    image: artAssets.cardTapeWorm,
    stats: { scrap: 12, atk: 28, def: 34, surveillance: 8 },
    flavor: "Magnetic Coil — a writhing fusion of obsolete analog media and salvaged cybernetics, lurking in the digital ruins to ensnare the unwary.",
    rarity: "legendary",
  },
  {
    id: "last-hero",
    name: "THE LAST HERO",
    role: "BOSS UNIT — ECHO OF HOPE",
    faction: "BOSS",
    cardNo: "107/133",
    image: artAssets.cardLastHero,
    stats: { scrap: 12, atk: 26, def: 30, surveillance: 5 },
    flavor: "Echo of Hope — the last beacon of hope in the digital wasteland, fighting to restore the harmony of the old world from the chaos of the new.",
    rarity: "legendary",
  },
  {
    id: "synth-ronin",
    name: "THE SYNTH-RONIN",
    role: "BOSS UNIT — CIRCUIT SHADOW DRIFT",
    faction: "BOSS",
    cardNo: "108/133",
    image: artAssets.cardSynthRonin,
    stats: { scrap: 15, atk: 33, def: 41, surveillance: 6 },
    flavor: "Circuit Shadow — a silent wanderer of the digital wastes, weaving code and steel to dismantle the remnants of the old world.",
    rarity: "legendary",
  },
  {
    id: "cybernetic-revival-chamber",
    name: "WASTELAND RUNNER — 'CYBERNETIC REVIVAL' CHAMBER",
    role: "TERRAIN — MEDICAL NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "109/133",
    image: artAssets.cardCyberneticRevivalChamber,
    stats: { scrap: 38, atk: "N/A", def: "N/A", surveillance: 7 },
    flavor: "REVIVE: once per round, return a destroyed non-Mutant unit from your scrap pile to the field with 5 HP. CYBER-MEDIC: while you control a Cyber-Medic, heal all your units for 2 HP each round. OVERCLOCK: no Scrap spent, your Cyber-Medic units gain +5 Surveillance. 'Death is just a system failure. And systems can be rebooted.'",
    rarity: "epic",
  },
  {
    id: "cybernetic-repair-bay",
    name: "WASTELAND RUNNER — 'CYBERNETIC REPAIR' BAY",
    role: "TERRAIN — WORKSHOP NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "110/133",
    image: artAssets.cardCyberneticRepairBay,
    stats: { scrap: 42, atk: "N/A", def: "N/A", surveillance: 8 },
    flavor: "REPAIR-DRIVE: once per round, repair a damaged non-Vehicle unit for 5 HP. CYBER-TECH: while you control a Cyber-Tech, give a unit in your hand +3 ATK each round. OVERCLOCK: no Scrap spent, your Cyber-Tech units gain +5 Surveillance. 'Rust is the enemy. We are the cure.'",
    rarity: "epic",
  },
  {
    id: "cybernetic-archive-vault",
    name: "WASTELAND RUNNER — 'CYBERNETIC ARCHIVE' VAULT",
    role: "TERRAIN — KNOWLEDGE NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "111/133",
    image: artAssets.cardCyberneticArchiveVault,
    stats: { scrap: 45, atk: "N/A", def: "N/A", surveillance: 9 },
    flavor: "DATA-RETRIEVAL: when an Archivist unit is played to this lane, draw a card. PRESERVE: while you control an Archivist, return a destroyed non-Vehicle unit from your scrap pile to your hand each round. OVERCLOCK: no Scrap spent, your Archivist units gain +5 Surveillance. 'The past is not dead. It is merely waiting to be downloaded.'",
    rarity: "epic",
  },
  {
    id: "cybernetic-arsenal-forge",
    name: "WASTELAND RUNNER — 'CYBERNETIC ARSENAL' FORGE",
    role: "TERRAIN — PRODUCTION NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "112/133",
    image: artAssets.cardCyberneticArsenalForge,
    stats: { scrap: 50, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "FORGE-DRIVE: while you control a Cyber-Smith, gain 5 SCRAP each round. ARMAMENT-OVERLOAD: once per round, deal 5 damage to a target unit to give a Vehicle in your hand +3 ATK. OVERCLOCK: no Scrap spent, your Vehicle units gain +5 ATK. 'From fire and steel, we build the instruments of our vengeance.'",
    rarity: "legendary",
  },
  {
    id: "cybernetic-refinery-complex",
    name: "WASTELAND RUNNER — 'CYBERNETIC REFINERY' COMPLEX",
    role: "TERRAIN — RESOURCE NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "113/133",
    image: artAssets.cardCyberneticRefineryComplex,
    stats: { scrap: 60, atk: "N/A", def: "N/A", surveillance: 9 },
    flavor: "REFINERY-DRIVE: while you control a Refinery-Operator, gain 10 SCRAP each round. CONVERSION-OVERLOAD: once per round, spend 5 SCRAP to give a unit in your hand +2 ATK and +2 DEF. OVERCLOCK: no Scrap spent, your Refinery-Operator units gain +5 Surveillance. 'We turn the refuse of the old world into the fuel of the new.'",
    rarity: "legendary",
  },
  {
    id: "kai-vagabond",
    name: "KAI — 'THE VAGABOND'",
    role: "VANGUARD UNIT — WASTELAND SURVIVOR",
    faction: "WASTELAND VANGUARD",
    cardNo: "114/133",
    image: artAssets.cardKaiVagabond,
    stats: { scrap: 11, atk: 14, def: 22, surveillance: 8 },
    flavor: "GUARD: enemies must target Kai before any other unit; if his DEF falls below 10, he gains +5 ATK. CURSED IRON: when Kai destroys an enemy, gain 2 SCRAP. 'The weight of the waste is my burden, but the blade is my will.'",
    rarity: "rare",
  },
  {
    id: "elara-scout",
    name: "ELARA — 'THE SCOUT'",
    role: "BLACK-OPS NET UNIT — RECON SPECIALIST",
    faction: "BLACK-OPS NET",
    cardNo: "115/133",
    image: artAssets.cardElaraScout,
    stats: { scrap: 13, atk: 11, def: 17, surveillance: "∞" },
    flavor: "NIGHT VISION: Elara ignores Concealment and Hidden. SIGNAL 1: +3 ATK while you control 2+ other same-faction cards. VIPER'S MARK: when Elara attacks, the target cannot Guard or Block this round. 'Distance is just another variable. I see everything before they pull the pin.'",
    rarity: "legendary",
  },
  {
    id: "rez-waste-bearer",
    name: "REZ — 'BEARER OF THE WASTE'",
    role: "MUTANT UNIT — JUGGERNAUT",
    faction: "MUTANT",
    cardNo: "116/133",
    image: artAssets.cardRezWasteBearer,
    stats: { scrap: 15, atk: 18, def: 26, surveillance: 10 },
    flavor: "CORRUPTED 3: at the start of your turn, Rez deals 3 damage to your Commander. OVERCLOCK: no Scrap spent, Rez gains Guard and +5 DEF. IMPACT: when Rez destroys a target, adjacent enemies are Stunned for a round. 'Bones crack like dry timber when the Atlas Cracker swings.'",
    rarity: "legendary",
  },
  {
    id: "sector-9-lockdown-perimeter",
    name: "SECTOR 9 — 'LOCKDOWN' PERIMETER",
    role: "TERRAIN — FORTIFIED COMPLEX",
    faction: "WASTELAND VANGUARD",
    cardNo: "117/133",
    image: artAssets.cardSector9LockdownPerimeter,
    stats: { scrap: 25, atk: "N/A", def: 40, surveillance: 7 },
    flavor: "ACTIVE PERIMETER: enemy units played to this lane are revealed before deployment. RIOT PROTOCOL: all units in this lane take 2 damage each round. OVERCLOCK: no Scrap spent, your Commander gains +5 DEF. 'The city protects itself. First, it locks the doors.'",
    rarity: "epic",
  },
  {
    id: "sector-9-chaos-engine",
    name: "SECTOR 9 — 'CHAOS ENGINE' AL RIOTBALL ARENA",
    role: "TERRAIN — VOLATILE FIELD",
    faction: "RIOTBALL",
    cardNo: "118/133",
    image: artAssets.cardSector9ChaosEngine,
    stats: { scrap: 20, atk: "N/A", def: "N/A", surveillance: 9 },
    flavor: "AL RIOTBALL: units played to this lane flip a coin — +5 ATK or 3 damage. POWER SURGE: each round the controlling player flips — 5 SCRAP to them or their opponent. OVERCLOCK: no Scrap spent, your AL Riotball units gain +5 DEF. 'Victory isn't about points. It's about survival.'",
    rarity: "epic",
  },
  {
    id: "cybernetic-data-spy-network",
    name: "WASTELAND RUNNER — 'CYBERNETIC DATA-SPY' NETWORK",
    role: "TERRAIN — SURVEILLANCE NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "119/133",
    image: artAssets.cardDataSpyNetwork,
    stats: { scrap: 35, atk: "N/A", def: "N/A", surveillance: 7 },
    flavor: "DATA-TAP: when an Intel unit is played to this lane, look at the opponent's hand and copy a card. JAM: while you control a Data-Spy unit, disable an enemy unit's ability for one round. OVERCLOCK: no Scrap spent, your Intel units gain +5 Surveillance. 'We know what they know before they know it.'",
    rarity: "epic",
  },
  {
    id: "omega-protocol",
    name: "WASTELAND RUNNER — 'OMEGA' PROTOCOL",
    role: "TERRAIN — NEXUS NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "120/133",
    image: artAssets.cardOmegaProtocol,
    stats: { scrap: 75, atk: "N/A", def: "N/A", surveillance: 9 },
    flavor: "OMEGA-ACCESS: when an Elite unit is played to this lane, gain Overclock for all your units this round. LOCKDOWN: while you control an Omega-Protocol unit, lock an opponent's lane once per round. OVERCLOCK: no Scrap spent, your Elite units gain +5 ATK. 'The ultimate key to the city's deepest secrets. Use it wisely.'",
    rarity: "legendary",
  },
  {
    id: "scavengers-guild",
    name: "WASTELAND RUNNER — 'SCAVENGERS' GUILD",
    role: "TERRAIN — RESOURCE GUILD",
    faction: "WASTELAND VANGUARD",
    cardNo: "121/133",
    image: artAssets.cardScavengersGuild,
    stats: { scrap: 85, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "SCAVENGE: when a Tech, Mutant, or Intel unit is played to this lane, gain 2 SCRAP and draw a card. GUILD-MASTER: while you control a Scavenger, upgrade a unit in your hand by +2 each round. OVERCLOCK: no Scrap spent, your units in this lane gain +5 Surveillance. 'We don't make the future, we dig it up.'",
    rarity: "legendary",
  },
  {
    id: "technomancers-cabal",
    name: "WASTELAND RUNNER — 'TECHNOMANCERS' CABAL",
    role: "TERRAIN — PSIONIC WORKSHOP",
    faction: "WASTELAND VANGUARD",
    cardNo: "122/133",
    image: artAssets.cardTechnomancersCabal,
    stats: { scrap: 95, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "TECHNOMANCY: when a Tech, Mutant, or Intel unit is played to this lane, choose one — draw a card, gain 3 SCRAP, or give a unit +1/+1. PSIONIC-LINK: while you control a Technomancer, look at the top two cards of your deck and draw one each round. OVERCLOCK: no Scrap spent, your units in this lane gain +5 ATK. 'We are the bridge between machine, mind, and the unknown.'",
    rarity: "legendary",
  },
  {
    id: "nexus-convergence",
    name: "WASTELAND RUNNER — 'NEXUS' CONVERGENCE",
    role: "TERRAIN — ULTIMATE NEXUS",
    faction: "WASTELAND VANGUARD",
    cardNo: "123/133",
    image: artAssets.cardNexusConvergence,
    stats: { scrap: 115, atk: "N/A", def: "N/A", surveillance: 12 },
    flavor: "NEXUS-CONVERGENCE: when ANY unit is played to this lane, gain Overclock for all your units and copy one effect from any card in play. DATA-OVERLOAD: while you control a Nexus Operative, lock the opponent's hand for one round. OVERCLOCK: no Scrap spent, ALL your units gain +3 ATK and +2 DEF. 'Everything converges here. The past, the present, the future. And the key to it all.'",
    rarity: "legendary",
  },
  {
    id: "nexus-prime-core",
    name: "WASTELAND RUNNER — 'NEXUS' PRIME CORE",
    role: "TERRAIN — PRIME NEXUS",
    faction: "WASTELAND VANGUARD",
    cardNo: "124/133",
    image: artAssets.cardNexusPrimeCore,
    stats: { scrap: 100, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "NEXUS-ACCESS: when any unit is played to this lane, gain 3 SCRAP and Overclock all your units for the round. CENTRAL-CONTROL: while you control a Nexus Operative, take control of an enemy unit for one round. OVERCLOCK: no Scrap spent, your units in all lanes gain +5 ATK. 'All paths lead to the Nexus. All power flows from it.'",
    rarity: "legendary",
  },
  {
    id: "cybernetic-veterans-legion",
    name: "WASTELAND RUNNER — 'CYBERNETIC VETERANS' LEGION",
    role: "TERRAIN — COMMAND POST",
    faction: "WASTELAND VANGUARD",
    cardNo: "125/133",
    image: artAssets.cardCyberneticVeteransLegion,
    stats: { scrap: 105, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "VETERAN-LEADERSHIP: when a Vanguard, Black-Ops, or AL Riotball unit is played to this lane, it gains Guard and +2 DEF. COMMAND-HUB: while you control a Veteran unit, look at the top card of your deck and put it on the bottom each round. OVERCLOCK: no Scrap spent, your units in this lane gain +3/+3. 'We are the living history. We are the hardened core.'",
    rarity: "legendary",
  },
  {
    id: "chronos-vortex",
    name: "WASTELAND RUNNER — 'CHRONOS' VORTEX",
    role: "TERRAIN — TEMPORAL ANOMALY",
    faction: "WASTELAND VANGUARD",
    cardNo: "126/133",
    image: artAssets.cardChronosVortex,
    stats: { scrap: 105, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "TEMPORAL-SHIFT: when a Tech, Mutant, or Intel unit is played to this lane, re-roll its entry effect and trigger it again. TIME-LOCK: while you control a Chronos-Agent, lock a unit — it cannot act or trigger abilities for one round. OVERCLOCK: no Scrap spent, your units in this lane gain +5 ATK and +5 Surveillance. 'Time is not a river. It is a mirror we can bend.'",
    rarity: "legendary",
  },
  {
    id: "synthetic-ascension-core",
    name: "WASTELAND RUNNER — 'SYNTHETIC ASCENSION' CORE",
    role: "TERRAIN — ASCENSION NEXUS",
    faction: "WASTELAND VANGUARD",
    cardNo: "127/133",
    image: artAssets.cardSyntheticAscensionCore,
    stats: { scrap: 100, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "ASSIMILATION: when a Tech, Mutant, or Intel unit is played to this lane, you may transform it into a Synthetic unit. SYNTHETIC-NETWORK: while you control a Synthetic unit, all your units gain +1/+1 each round. OVERCLOCK: no Scrap spent, your Synthetic units gain +5 ATK and +5 Surveillance. 'The flesh is weak. The code is eternal. We are one.'",
    rarity: "legendary",
  },
  {
    id: "cyber-psionic-matrix",
    name: "WASTELAND RUNNER — 'CYBER-PSIONIC' MATRIX",
    role: "TERRAIN — MORKSAL NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "128/133",
    image: artAssets.cardCyberPsionicMatrix,
    stats: { scrap: 105, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "MATRIX-ACCESS: when a Tech, Mutant, or Intel unit is played to this lane, Overclock all your units for the round and draw a card. PSIONIC-OVERLOAD: while you control a Cyber-Psionic unit, gain 5 SCRAP or give a unit +2/+2 once per round. OVERCLOCK: no Scrap spent, your units in this lane gain +5 ATK. 'The ultimate key to the city's deepest secrets. The network is our mind.'",
    rarity: "legendary",
  },
  {
    id: "omega-project",
    name: "WASTELAND RUNNER — 'THE OMEGA PROJECT'",
    role: "TERRAIN — CONVERGENCE NODE",
    faction: "WASTELAND VANGUARD",
    cardNo: "129/133",
    image: artAssets.cardOmegaProject,
    stats: { scrap: 150, atk: "N/A", def: "N/A", surveillance: 10 },
    flavor: "CONVERGENCE: units played to this lane gain Overclock, Ward, and Haste. SYNCHRONIZATION: once per round, while you control a unit with Overclock, draw two cards and gain 10 SCRAP. OVERCLOCK: no Scrap spent, all your units gain +10 ATK and +5 DEF. 'The future we built. The past we reclaimed. The present we mastered. It all converges here.'",
    rarity: "legendary",
  },
  {
    id: "chrono-steward-aethel",
    name: "WASTELAND RUNNER — 'CHRONO-STEWARD' AETHEL",
    role: "UNIT — CHRONO-KEEPER",
    faction: "WASTELAND VANGUARD",
    cardNo: "130/133",
    image: artAssets.cardChronoStewardAethel,
    stats: { scrap: 135, atk: 10, def: 15, surveillance: 10 },
    flavor: "CHRONO-STABLE: Aethel cannot be Hidden, Warded, or Removed by opponent card effects. TEMPORAL-ADJUST: when you play a Tech, Mutant, or Intel unit, change its ATK or DEF by 1. OVERCLOCK: no Scrap spent, Aethel gains +2 ATK. 'Time is not a river, it's a tapestry. I simply mend the snags.'",
    rarity: "legendary",
  },
  {
    id: "chrono-keeper-elara",
    name: "WASTELAND RUNNER — 'CHRONO-KEEPER' ELARA",
    role: "UNIT — CHRONO-KEEPER ELITE",
    faction: "WASTELAND VANGUARD",
    cardNo: "131/133",
    image: artAssets.cardChronoKeeperElara,
    stats: { scrap: 145, atk: 12, def: 18, surveillance: 15 },
    flavor: "CHRONO-STABLE: Elara cannot be Hidden, Warded, or Removed by opponent card effects. TEMPORAL-LOCK: when you play a Tech, Mutant, or Intel unit, lock an opponent's lane. OVERCLOCK: no Scrap spent, Elara gains +3 ATK. 'Time is not a river, it's a tapestry. I simply mend the snags.'",
    rarity: "legendary",
  },
  {
    id: "chrono-architect-kaelen",
    name: "WASTELAND RUNNER — 'CHRONO-ARCHITECT' KAELEN",
    role: "UNIT — CHRONO-KEEPER MASTER",
    faction: "WASTELAND VANGUARD",
    cardNo: "132/133",
    image: artAssets.cardChronoArchitectKaelen,
    stats: { scrap: 150, atk: 14, def: 20, surveillance: 20 },
    flavor: "CHRONO-STABLE: Kaelen cannot be Hidden, Warded, or Removed by opponent card effects. TEMPORAL-SHIFT: when you play a Tech, Mutant, or Intel unit, move it to an adjacent lane and it gains Haste. OVERCLOCK: no Scrap spent, Kaelen gains +4 ATK. 'The past is mutable. The future is a choice. I design both.'",
    rarity: "legendary",
  },
  {
    id: "chrono-lord-kaeleb",
    name: "WASTELAND RUNNER — 'CHRONO-LORD' KAELEB",
    role: "UNIT — CHRONO-LORD COMMANDER",
    faction: "WASTELAND VANGUARD",
    cardNo: "133/133",
    image: artAssets.cardChronoLordKaeleb,
    stats: { scrap: 175, atk: 22, def: 30, surveillance: 28 },
    flavor: "CHRONO-STABLE: Kaeleb cannot be Hidden, Warded, or Removed by opponent card effects. CHRONO-COMMAND: once per round, activate the Overclock effect of another unit you control without spending Scrap. OVERCLOCK: no Scrap spent, Kaeleb gains +8 ATK and +8 DEF. 'Time is a fortress. I am its warden.'",
    rarity: "legendary",
  },
];

export const dossiers = [
  {
    id: "dolo",
    code: "DOSSIER 01",
    name: "DOLO WASTELAND RUNNER",
    role: "WASTELAND RUNNER",
    status: "SHEET LIVE",
    brief: "Cybernetically enhanced Red Force legend built by the Alliance League — fifteen years of AL Riotball dominance ended at the 2350 Championship Final when the League declared him obsolete and scrapped the chassis. Salvaged and rebuilt by Kaelen in the Old Atlanta Underground, Dolo now runs the wasteland with a cargo harness, enhanced servos, and a mono-filament blade. 3,291 successful deliveries and counting.",
    image: artAssets.sheetDolo,
    imageType: "sheet",
  },
  {
    id: "deacon-ramirez",
    code: "DOSSIER 02",
    name: "GENERAL DEACON RAMIREZ",
    role: "SAFE ZONE COMMANDER",
    status: "SHEET LIVE",
    brief: "Official character sheet received with armor, sword, rifle, head studies, and safe-zone defense details.",
    image: artAssets.sheetDeaconRamirez,
    imageType: "sheet",
  },
  {
    id: "safe-zone-army",
    code: "DOSSIER 03",
    name: "APOCALYPSE SAFE ZONE ARMY",
    role: "DEFENSE FORCES",
    status: "SHEET LIVE",
    brief: "Official defense-force sheet received with infantry, land vehicles, air systems, sea forces, and deployment schematics.",
    image: artAssets.sheetSafeZoneArmy,
    imageType: "sheet",
  },
  {
    id: "new-atlanta-defense",
    code: "DOSSIER 04",
    name: "NEW ATLANTA DEFENSE FORCE",
    role: "MILITARY SYSTEMS",
    status: "SHEET LIVE",
    brief: "Official military-systems schematic received with ground, air, sea, radar, and coastal defense assets.",
    image: artAssets.sheetNewAtlantaDefense,
    imageType: "sheet",
  },
];

export const characterBookEntries = [
  ...dossiers,
  {
    id: "goji",
    code: "DOSSIER 05",
    name: "GOJI",
    role: "CYBORG WITCH",
    status: "SHEET LIVE",
    brief: "Apocrypha cyborg witch sheet received with mechanical wings, cable hair tentacles, and iron samurai mask details.",
    image: artAssets.sheetGoji,
    imageType: "sheet",
  },
  {
    id: "koji",
    code: "DOSSIER 06",
    name: "KOJI",
    role: "CYBORG SAMURAI",
    status: "SHEET LIVE",
    brief: "Apocalypse cyborg samurai chimpanzee sheet received with full-body, profile, back-view, head-shot, and mask details.",
    image: artAssets.sheetKoji,
    imageType: "sheet",
  },
  {
    id: "opus",
    code: "DOSSIER 07",
    name: "OPUS",
    role: "STEEL SYMPHONY",
    status: "SHEET LIVE",
    brief: "Official Chronicles of the Steel Symphony sheet received with action poses, keyboard-step detail, and instrument-axe studies.",
    image: artAssets.sheetOpus,
    imageType: "sheet",
  },
  {
    id: "lil-girl",
    code: "DOSSIER 08",
    name: "LIL GIRL",
    role: "BOUNTY HUNTER",
    status: "SHEET LIVE",
    brief: "Apocalypse cyborg sniper sheet received with custom heavy-duty rifle, cybernetic eye, cloak, and pose studies.",
    image: artAssets.sheetLilGirl,
    imageType: "sheet",
  },
  {
    id: "drone-boy",
    code: "DOSSIER 09",
    name: "DRONE BOY",
    role: "SPY",
    status: "SHEET LIVE",
    brief: "Apocalypse cyborg spy sheet received with drone bay, sensor array, stealth coating, and drone details.",
    image: artAssets.sheetDroneBoy,
    imageType: "sheet",
  },
  {
    id: "dolo-vinyl-duo",
    code: "DOSSIER 10",
    name: "DOLO & VINYL ALLY",
    role: "DUO TRANSMISSION",
    status: "SHEET LIVE / NAME PENDING",
    brief: "Official field illustration received with Dolo beside an unnamed vinyl-armored swordswoman.",
    image: artAssets.sheetDuo,
    imageType: "sheet",
  },
  {
    id: "vinyl-ally",
    code: "DOSSIER 11",
    name: "VINYL BLADE ALLY",
    role: "CYBORG SWORDSWOMAN",
    status: "SHEET LIVE / NAME PENDING",
    brief: "Detailed sheet received with profile studies, katana, shuriken, cybernetic hand, and Dolo field pose.",
    image: artAssets.sheetVinylAlly,
    imageType: "sheet",
  },
  {
    id: "bio-mech-giant",
    code: "DOSSIER 12",
    name: "BIO-MECH GIANT",
    role: "HOSTILE CLASS",
    status: "SHEET LIVE / NAME PENDING",
    brief: "Skeletal bio-mechanical giant sheet received with core, claw, profile, and ruined-city action studies.",
    image: artAssets.sheetBioGiant,
    imageType: "sheet",
  },
  {
    id: "speaker-demon",
    code: "DOSSIER 13",
    name: "SPEAKER DEMON",
    role: "HOSTILE CLASS",
    status: "SHEET LIVE / NAME PENDING",
    brief: "Sonic bio-mechanical creature sheet received with speaker arrays, stance studies, and equipment details.",
    image: artAssets.sheetSpeakerDemon,
    imageType: "sheet",
  },
  {
    id: "mute-cyborg",
    code: "DOSSIER 14",
    name: "MUTE CYBORG",
    role: "HOSTILE CLASS",
    status: "SHEET LIVE / NAME PENDING",
    brief: "Sonic-warfare sheet received with masked cyborg, human silhouette, destroyed speakers, and mute-signal motifs.",
    image: artAssets.sheetMuteCyborg,
    imageType: "sheet",
  },
  {
    id: "riff",
    code: "DOSSIER 15",
    name: "RIFF",
    role: "MELODIE TACTICIAN",
    status: "SHEET LIVE",
    brief: "Official Melodie Tactician sheet received with skeletal design, saxophone-weapon studies, stance, and pedestal detail.",
    image: artAssets.sheetRiff,
    imageType: "sheet",
  },
  {
    id: "ai-z4-harpy",
    code: "DOSSIER 16",
    name: "A.I. Z-4 HARPY",
    role: "A.I. DEFENSE",
    status: "SHEET LIVE",
    brief: "Official A.I. patrol sheet received with Harpy's rotary armor, defense cannon, and safe-zone flight profile.",
    image: artAssets.sheetAiUnits,
    imageType: "sheet",
  },
  {
    id: "unit-a7-skelter",
    code: "DOSSIER 17",
    name: "UNIT A-7 SKELTER",
    role: "A.I. SENTINEL",
    status: "SHEET LIVE",
    brief: "Official A.I. patrol sheet received with Skelter's bipedal sentinel frame, rifle, and rotor assembly.",
    image: artAssets.sheetAiUnits,
    imageType: "sheet",
  },
  {
    id: "ai-t12-behemoth",
    code: "DOSSIER 18",
    name: "A.I. T-12 BEHEMOTH",
    role: "A.I. TRANSPORT",
    status: "SHEET LIVE",
    brief: "Official A.I. patrol sheet received with Behemoth's armored transport body, cannon, and heavy-landing profile.",
    image: artAssets.sheetAiUnits,
    imageType: "sheet",
  },
  {
    id: "desert-scout-sphere",
    code: "DOSSIER 19",
    name: "DESERT SCOUT SPHERE",
    role: "SNIPER BOUNTY HUNTER",
    status: "SHEET LIVE",
    brief: "Official Desert Scout Sphere sheet received with cockpit module, integrated sniper rifle, tread wheel, sensor suite, and optics.",
    image: artAssets.sheetScoutSphere,
    imageType: "sheet",
  },
  {
    id: "wild-belk",
    code: "DOSSIER 20",
    name: "WILD BELK",
    role: "MUTATED WILDLIFE",
    status: "SHEET LIVE",
    brief: "Official Wild Belk sheet received with herd, close-up, antler, tentacle, and ruined-city studies.",
    image: artAssets.sheetMutantElk,
    imageType: "sheet",
  },
  {
    id: "giga",
    code: "DOSSIER 21",
    name: "GIGA",
    role: "MUTATED WILDLIFE",
    status: "SHEET LIVE",
    brief: "Official Giga sheet received with colony tornado, close-up, group flight, and ruined-city studies.",
    image: artAssets.sheetWaspSwarm,
    imageType: "sheet",
  },
  {
    id: "advanced-defense-systems",
    code: "DOSSIER 22",
    name: "ADVANCED DEFENSE SYSTEMS",
    role: "VEHICLE SYSTEMS",
    status: "SHEET LIVE",
    brief: "Official Redoubt's Shield sheet received with advanced land, air, sea, missile, radar, and integrated defense systems.",
    image: artAssets.sheetAdvancedDefense,
    imageType: "sheet",
  },
  {
    id: "agad-audit-division",
    code: "DOSSIER 23",
    name: "AETHER-GRID AUDIT DIVISION",
    role: "ENFORCEMENT DIVISION",
    status: "SIGIL LIVE",
    brief: "AGAD auditors maintain the public decibel mesh across every safe zone. The division logs noise violations to the local security ledger, suspends market access, route permits, and power allocation for repeat breaches, and dispatches Black-Ops Net acoustic units when a signal spike is judged deliberate.",
    image: artAssets.agadSigil,
    imageType: "sheet",
  },
  {
    id: "bonau-acoustic-units",
    code: "DOSSIER 24",
    name: "BLACK-OPS NET ACOUSTIC UNITS",
    role: "ENFORCEMENT DIVISION",
    status: "SIGIL LIVE",
    brief: "BONAU is the field arm of noise enforcement. Its acoustic units triangulate deliberate violations through the decibel mesh, move silently after curfew, and clear offending signals without exposing protected safehouse channels. Repeat offenders answer to the Audit Division's ledger.",
    image: artAssets.bonauSigil,
    imageType: "sheet",
  },
  {
    id: "silent-night-joint-command",
    code: "DOSSIER 25",
    name: "SILENT NIGHT JOINT COMMAND",
    role: "ENFORCEMENT DIVISION",
    status: "SIGIL PAIR LIVE",
    brief: "The two divisions operate as one protocol. AGAD's auditors watch the decibel mesh and flag the spike; BONAU units receive mesh coordinates, respond in the field, and clear the source before it can map a safehouse route. Every joint action closes in the security ledger — warning first, suspension second, inspection last.",
    image: artAssets.silentNightJoint,
    imageType: "sheet",
  },
  {
    id: "unit-07-enforcer",
    code: "DOSSIER 26",
    name: "UNIT 07 — THE ENFORCER",
    role: "AL RIOTBALL DIVISION",
    status: "ROSTER LIVE",
    brief: "Red Force's Core-possession specialist and the face of the 2355 championship card. Servo-actuator pistons, a magnetic claw gauntlet rated for Core grip at full sprint, multi-phase optic sensors, and reactor-core venting for collision heat. Built to take the Core through the middle of a White Guard wall — and come out the other side.",
    image: artAssets.unitEnforcer,
    imageType: "sheet",
  },
  {
    id: "unit-09-scythe",
    code: "DOSSIER 27",
    name: "UNIT 09 — THE SCYTHE",
    role: "AL RIOTBALL DIVISION",
    status: "ROSTER LIVE",
    brief: "Striker frame, Red Force key player. Agility 9.5 / Power 7.0 — the fastest unit on the 2355 roster. The Scythe cuts defensive lines on the outside arc before the Guard's formation can rotate, and scores off the leap.",
    image: artAssets.unitScythe,
    imageType: "sheet",
  },
  {
    id: "unit-03-wall",
    code: "DOSSIER 28",
    name: "UNIT 03 — THE WALL",
    role: "AL RIOTBALL DIVISION",
    status: "ROSTER LIVE",
    brief: "Heavy defender frame. Agility 5.5 / Power 9.5 — the strongest unit in the league. The Wall plants at the hoop line and dares strikers to test the shield plate. Listed opposite Unit 07 on the championship card for a reason.",
    image: artAssets.unitWall,
    imageType: "sheet",
  },
  {
    id: "unit-05-overmind",
    code: "DOSSIER 29",
    name: "UNIT 05 — THE OVERMIND",
    role: "AL RIOTBALL DIVISION",
    status: "ROSTER LIVE",
    brief: "Tactician unit. Strategy 9.0 / Support 8.5 — runs the entire play from mid-field on twin data-slates, reading the White Guard formation three passes ahead. Every Red Force counter-attack starts as an Overmind calculation.",
    image: artAssets.unitOvermind,
    imageType: "sheet",
  },
  {
    id: "kaelen",
    code: "DOSSIER 30",
    name: "KAELEN",
    role: "SALVAGE ENGINEER",
    status: "ARTWORK PENDING",
    brief: "Scavenger-engineer from the fringes of Atlanta who knew the value of legendary tech. Kaelen pulled Dolo's core components from the League scrapyard and rebuilt him in a subterranean workshop beneath the Old Atlanta Underground — scavenged hydraulics, patchwork armor plating, cobbled-together weapons mounts. The wasteland's most dangerous runner exists because Kaelen refused to let a champion rust.",
  },
];

export function scrollToSection(id) {
  const target = `#${id}`;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -88 });
    return;
  }
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}
